import React from "react";

import { NavigateNext } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import { WarehouseProvider } from "../../../../../../context/WarehouseContext";
import { StorageBoxesPage } from "./StorageBoxes";
import { StorageBoxTypesPage } from "./StorageBoxTypes";
import { GeneralWrapper, HeaderBreadcrumbs, HeaderBreadcrumbsTitle } from "./styles";
import Warehouse from "./Warehouse";

interface Props {
  tabName: string;
  permission?: {
    edit: boolean;
    create: boolean;
  };
}

enum Pages {
  WAREHOUSES = "Warehouses",
  STORAGE_BOXES = "Storage boxes",
  STORAGE_BOX_TYPES = "Storage box types",
}

const ConfigurationGeneralTab = ({ tabName, permission }: Props) => {
  const { t: translate } = useTranslation();

  const setCurrentPage = () => {
    switch (tabName) {
      case Pages.WAREHOUSES:
        return <Warehouse permission={permission} />;
      case Pages.STORAGE_BOXES:
        return <StorageBoxesPage permission={permission} />;
      case Pages.STORAGE_BOX_TYPES:
        return <StorageBoxTypesPage permission={permission} />;
      default:
        return <Warehouse permission={permission} />;
    }
  };

  return (
    <GeneralWrapper>
      {/* <header className="mb-4">
        <HeaderBreadcrumbs separator={<NavigateNext />} aria-label="breadcrumb">
          <HeaderBreadcrumbsTitle isActive={false}>
            {translate("configurations")}
          </HeaderBreadcrumbsTitle>
          <HeaderBreadcrumbsTitle isActive={true}>
            {translate("warehousing")}
          </HeaderBreadcrumbsTitle>
          <HeaderBreadcrumbsTitle isActive={true} data-cy="breadcrumbsSubTitle">
            {tabName}
          </HeaderBreadcrumbsTitle>
        </HeaderBreadcrumbs>
      </header> */}
      <WarehouseProvider>{setCurrentPage()}</WarehouseProvider>
    </GeneralWrapper>
  );
};

export default ConfigurationGeneralTab;
